import React from 'react'
import { set } from 'lodash/fp'
import ReactSelect from 'react-select'
import SortIcon from '@mui/icons-material/Sort'
import { CreativeFilters } from '../helpers/creative.helpers'
import { SelectCreativeType } from 'components/FormFields/Select/SelectCreativeType'

interface Props {
  sortProp: string
  setSort: SetState<string>
  sortDirection: 'ASC' | 'DESC'
  setSortDirection: SetState<'ASC' | 'DESC'>
  filters?: CreativeFilters
  setFilters: SetState<CreativeFilters | undefined>
}

const sortOptions = [
  { label: 'Last Used', value: 'lastUsed' },
  { label: 'Name', value: 'name' },
]

export const CreativeFiltersPanel = (props: Props) => (
  <>
    <div>
      <p className="mb-1 text-xs font-semibold text-mm-neutral-1-600">Sort</p>
      <div className="flex">
        <div className="flex-1">
          <ReactSelect
            value={sortOptions.find(o => o.value === props.sortProp)}
            options={sortOptions}
            onChange={(newValue: any) => newValue && props.setSort(newValue.value)}
            openMenuOnClick
          />
        </div>
        <button
          type="button"
          onClick={() => props.setSortDirection(d => (d === 'ASC' ? 'DESC' : 'ASC'))}
          className="-ml-px flex flex-shrink-0 items-center space-x-2 rounded-r-md border border-mm-neutral-1-300 bg-mm-neutral-1-50 px-2 py-2 text-sm font-medium text-mm-neutral-1-700 hover:bg-mm-neutral-1-100"
        >
          <SortIcon className="h-5 w-5 text-mm-neutral-1-400" />
          <span>{props.sortDirection}</span>
        </button>
      </div>
    </div>

    <div>
      <p className="mb-1 text-xs font-semibold text-mm-neutral-1-600">Type</p>
      <SelectCreativeType
        value={props.filters?.type ?? []}
        placeholder="Any type"
        onSelectType={types => props.setFilters(set('type', types))}
      />
    </div>
  </>
)
